<template>
  <div class="g-counter">
      <div class="g-counter-l" @click.stop="execute(1, Infinity , 1, 0, true)">
        -
      </div>
      <input type="tel" :value="currentValue" 
       @input="handleInput"
       @change="$emit('change', currentValue)"
       maxlength="11"
       :readonly="readonly"
      >
      <div class="g-counter-r"  @click.stop="execute(1, Infinity , 1, 0, false)">
        +
      </div>
  </div>
</template>
<script>
export default {
  name: 'VCounter',

  data () {
    return {
      currentValue: this.value
    };
  },

  props: {
    value: {},
    readonly: Boolean
  },

  watch: {
    value (val) {
      this.currentValue = val;
    },
    currentValue (val) {
      this.$emit('input', val);
    }
  },

  methods: {
    handleInput (evt) {
      this.currentValue = evt.target.value;
    },
    execute (step = 1, max, min, digit, _do) {
      var val = parseFloat(this.format(this.currentValue, digit));
      if (_do) val -= step;
      if (!_do) val += step;
      if (val < min) {
        val = min;
      } else if (val > max) {
        val = max;
      }
      this.currentValue = this.format(val, digit);
    },
    format (val, digit) {
      if (isNaN(val)) {
        val = 0;
      }
      return parseFloat(val).toFixed(digit);
    }
  }
};
</script>
<style lang="scss">
@import "../../assets/scss/var.scss";
.g-counter {
  align-items: center;
  display: flex;
  .g-counter-l,
  .g-counter-r {
    border: solid 1px;
    color: #B4B4BA;
    width: 25px;
    height: 25px;
    display: inline-block;
    text-align: center;
    font-size: 2rem;
    line-height: 25px;
    margin: 0 5px;
    cursor: pointer;
  }
  input{
      width: 50px;
      height: 25px;
      border: solid 1px #B4B4BA;
      text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/base/counter.vue